import { useEffect } from "react";

const SITE_URL = (process.env.REACT_APP_SITE_URL || "").replace(/\/$/, "");

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!href) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const Seo = ({ title, description, path = "/" }) => {
  useEffect(() => {
    const full = title.includes("PRPO") ? title : `${title} | PRPO LTD`;
    document.title = full;
    setMeta("name", "description", description);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "PRPO LTD");
    setMeta("property", "og:locale", "en_GB");
    setMeta("name", "twitter:card", "summary_large_image");
    if (SITE_URL) {
      setMeta("property", "og:url", `${SITE_URL}${path}`);
      setMeta("property", "og:image", `${SITE_URL}/images/identity.webp`);
    }
    setCanonical(SITE_URL ? `${SITE_URL}${path}` : null);
  }, [title, description, path]);
  return null;
};
